import { DateTime } from "luxon"
import { SLOT_MINUTES } from "@/constants/ui"

export const clamp = (value: number, min: number, max: number): number => {
  if (max <= min) return min
  return Math.min(Math.max(value, min), max)
}

export const normalizeTime = (time: string | DateTime): DateTime => {
  if (typeof time === "string") {
    const dateTime = DateTime.fromISO(time)
    if (!dateTime.isValid) {
      throw new Error(`normalizeTime received an invalid ISO time string: ${time}`)
    }
    return dateTime
  }

  if (!time.isValid) {
    throw new Error(`normalizeTime received an invalid DateTime: ${time.invalidReason || "unknown reason"}`)
  }

  return time
}

export const isSlotWithinRange = (slot: DateTime, start: DateTime, end: DateTime): boolean => {
  return slot >= start && slot < end
}

export const positionForTime = (
  isoTime: string | null | undefined,
  startDt: DateTime,
  totalDurationMinutes: number,
): number | null => {
  if (!isoTime) return null
  if (totalDurationMinutes <= 0) return null
  const dt = normalizeTime(isoTime)
  const diff = dt.diff(startDt).as("minutes")
  return (diff / totalDurationMinutes) * 100
}

export const positionForDateTime = (dt: DateTime, startDt: DateTime, totalDurationMinutes: number): number => {
  if (totalDurationMinutes <= 0) return 0
  const diff = normalizeTime(dt).diff(startDt).as("minutes")
  return (diff / totalDurationMinutes) * 100
}

export const snapToSlot = (minutes: number, slotMinutes: number = SLOT_MINUTES): number => {
  return Math.round(minutes / slotMinutes) * slotMinutes
}
